module.exports = __webpack_public_path__ + "img/icon-danger.fcd23e92.svg";